import { type SxProps, type Theme } from "~/common/mui";

export const previewImageSx: SxProps<Theme> = {
  width: 1,
  height: 1,
  objectFit: "contain",
};

export const previewTwoImageSx: SxProps<Theme> = {
  width: 1,
  height: "auto",
  maxHeight: "50vh",
  objectFit: "contain",
};
